import { gql } from '@apollo/client';
import { client } from '../../../../../graphql/client';
import { ACCOUNTS_PAGE_MODE, AccountsPageMode } from '../../hooks/useAccountDeliveryDriverQuery';

export interface DriverPhotosInput {
    idDocumentImageS3Keys: string[];
    vehicleImageS3Keys: string[];
}

export interface UploadPhotoResult {
    accountId: number;
    success: boolean;
    errorMessage?: string;
}

export interface BatchUploadPhotosResponse {
    results: UploadPhotoResult[];
}

// DSP 入口
const BATCH_UPLOAD_DRIVER_PHOTOS = gql`
    mutation BatchUploadDriverPhotos($accountIds: [Long!]!, $photos: [DriverPhotosInput!]!) {
        batchUploadDriverPhotos(accountIds: $accountIds, photos: $photos) {
            results {
                accountId
                success
                errorMessage
            }
        }
    }
`;

// 总部入口：别名保持响应字段名与 DSP 入口一致
const BATCH_UPLOAD_DRIVER_PHOTOS_FOR_CENTRAL = gql`
    mutation BatchUploadDriverPhotosForCentral($accountIds: [Long!]!, $photos: [DriverPhotosInput!]!) {
        batchUploadDriverPhotos: batchUploadDriverPhotosForCentral(accountIds: $accountIds, photos: $photos) {
            results {
                accountId
                success
                errorMessage
            }
        }
    }
`;

// 仓库入口：别名保持响应字段名与 DSP 入口一致
const BATCH_UPLOAD_DRIVER_PHOTOS_FOR_WMS = gql`
    mutation BatchUploadDriverPhotosForWms($accountIds: [Long!]!, $photos: [DriverPhotosInput!]!, $warehouseId: Long!) {
        batchUploadDriverPhotos: batchUploadDriverPhotosForWms(accountIds: $accountIds, photos: $photos, warehouseId: $warehouseId) {
            results {
                accountId
                success
                errorMessage
            }
        }
    }
`;

export const batchUploadDriverPhotos = async (
    accountIds: number[],
    photos: Map<number, DriverPhotosInput>,
    mode?: AccountsPageMode,
    warehouseId?: number | null
): Promise<BatchUploadPhotosResponse | undefined> => {
    // 将 Map 转换为数组格式
    const photosArray = accountIds.map(accountId => {
        const photo = photos.get(accountId);
        if (!photo) {
            throw new Error(`Missing photos for accountId: ${accountId}`);
        }
        return {
            accountId,
            idDocumentImageS3Keys: photo.idDocumentImageS3Keys,
            vehicleImageS3Keys: photo.vehicleImageS3Keys
        };
    });

    let mutation;
    const variables: { accountIds: number[]; photos: typeof photosArray; warehouseId?: number } = {
        accountIds,
        photos: photosArray
    };
    if (mode === ACCOUNTS_PAGE_MODE.CENTRAL) {
        mutation = BATCH_UPLOAD_DRIVER_PHOTOS_FOR_CENTRAL;
    } else if (mode === ACCOUNTS_PAGE_MODE.WMS) {
        if (!warehouseId) {
            throw new Error('warehouseId is required in wms mode');
        }
        mutation = BATCH_UPLOAD_DRIVER_PHOTOS_FOR_WMS;
        variables.warehouseId = warehouseId;
    } else if (mode === ACCOUNTS_PAGE_MODE.DSP) {
        mutation = BATCH_UPLOAD_DRIVER_PHOTOS;
    } else {
        // 非三种入口之一时不发请求，不设默认入口
        return undefined;
    }

    const result = await client.mutate({
        mutation,
        variables
    });

    return result.data.batchUploadDriverPhotos;
};

